import { render, staticRenderFns } from "./workspaces_provider.vue?vue&type=template&id=282eafea&scoped=true&"
import script from "./workspaces_provider.vue?vue&type=script&lang=js&"
export * from "./workspaces_provider.vue?vue&type=script&lang=js&"
import style0 from "./workspaces_provider.vue?vue&type=style&index=0&id=282eafea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282eafea",
  null
  
)

export default component.exports